import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズの IT Operation Core ロゴアイコン
 */
export function ProductLogoSmallITOperationCore({
  size = 20,
  color = "#1874A1",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="M384 84c13.255 0 24 10.745 24 24v12c0 6.627-5.373 12-12 12H60v-24c0-13.255 10.745-24 24-24h300ZM108 132v168H60V132h48ZM276 348c0 6.627-5.373 12-12 12H72c-26.51 0-48-21.49-48-48 0-6.627 5.373-12 12-12h228c6.627 0 12 5.373 12 12v36Z"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M398.141 156c3.182 0 6.235 1.264 8.485 3.515l46.526 46.526a11.998 11.998 0 0 1 3.515 8.485V385c0 6.627-5.373 12-12 12H308c-6.627 0-12-5.373-12-12V168c0-6.627 5.373-12 12-12h90.141Zm-53.975 147.277a8 8 0 0 0-8 8v10.778a8 8 0 0 0 8 8h64.333a8 8 0 0 0 8-8v-10.778a8 8 0 0 0-8-8h-64.333Zm0-80.332a8 8 0 0 0-8 8v10.778a8 8 0 0 0 8 8h64.333a8 8 0 0 0 8-8v-10.778a8 8 0 0 0-8-8h-64.333Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
